import dayjs from 'dayjs';

export const formatDate = (date?: string, format?: string) =>
  date ? dayjs(date, format).format('DD/MM/YYYY') : '-';

export const formatFullDate = (date?: string, format?: string) =>
  date ? dayjs(date, format).format('Do MMMM YYYY') : '-';

export const formatDateTime = (date?: string, format?: string) =>
  date ? dayjs(date, format).format('DD/MM/YYYY h:mma') : '-';

export const convertMillisecondsToSeconds = (milliseconds: number) =>
  Math.floor(milliseconds / 1000);

export const convertMillisecondsToMinutesAndSeconds = (milliseconds: number) =>
  dayjs(milliseconds).format('mm:ss');

export const getOrdinal = (number: number) => {
  let ordinal = 'th';

  if (number % 10 === 1 && number % 100 !== 11) {
    ordinal = 'st';
  } else if (number % 10 === 2 && number % 100 !== 12) {
    ordinal = 'nd';
  } else if (number % 10 === 3 && number % 100 !== 13) {
    ordinal = 'rd';
  }

  return `${number}${ordinal}`;
};
